/* jshint esversion: 6 */
/* globals $, isCMS */

/**
 * SidebarController class manages the sidebar functionality in the application.
 * It handles various interactions and state management related to the sidebar.
 */
export default class SidebarController {
    /**
     * Constructor for SidebarController.
     * @param {Object} $scope - AngularJS scope object.
     * @param {Object} $bridges - Bridges service for various utilities.
     * @param {Object} $signals - Signals service for event handling.
     * @param {Object} $location - AngularJS $location service.
     * @param {Object} $config - Configuration service.
     */
    constructor($scope, $bridges, $signals, $location, $config) {
        this.$scope = $scope;
        this.$bridges = $bridges;
        this.$signals = $signals;
        this.$location = $location;
        this.$config = $config;

        // Bind methods to the current instance to maintain context
        this.redirectToSheet = this.redirectToSheet.bind(this);
        this.onBackgroundResourcesClick = this.onBackgroundResourcesClick.bind(this);
        this.onStatusMapClick = this.onStatusMapClick.bind(this);
        this.onStatusMapItemClick = this.onStatusMapItemClick.bind(this);
        this.onStatusMapSortByButtonClick = this.onStatusMapSortByButtonClick.bind(this);
        this.onStatusMapSubquestionItemClick = this.onStatusMapSubquestionItemClick.bind(this);
        this.onStatusMapSortButtonClick = this.onStatusMapSortButtonClick.bind(this);

        // Determine sidebar visibility based on CMS and preview mode
        if (isCMS) {
            this.$scope.isCMS = true;
            this.$scope.hideSidebar = false;
            if (!this.$config.isPreviewMode()) {
                this.$scope.hideSidebar = true;
            }
        } else {
            this.$scope.isCMS = false;
            this.$scope.hideSidebar = false;
        }

        // Controller meta setup
        this.$scope._logIdentifier = 'SidebarController';
        this.$logger = this.$bridges.logger();
        this.$logger.logEnter(this.$scope, 'init' + this.$scope._logIdentifier);

        // Assign methods to scope for use in templates
        this.$scope.onBackgroundResourcesClick = this.onBackgroundResourcesClick;
        this.$scope.onStatusMapClick = this.onStatusMapClick;
        this.$scope.onStatusMapItemClick = this.onStatusMapItemClick;
        this.$scope.onStatusMapSortByButtonClick = this.onStatusMapSortByButtonClick;
        this.$scope.onStatusMapSubquestionItemClick = this.onStatusMapSubquestionItemClick;
        this.$scope.onStatusMapSortButtonClick = this.onStatusMapSortButtonClick;

        this.$logger.logExit(this.$scope, 'init' + this.$scope._logIdentifier);
    }

    /**
     * Redirects to a specific sheet.
     * @param {Object} sheet - The sheet object to redirect to.
     */
    redirectToSheet(sheet) {
        let path;

        if (isCMS) {
            path = '/sheet/' + this.$scope.task.getUUID() + '/' + sheet.getUUID();
            if (this.$config.isPreviewMode()) {
                path = '/sheet/' + this.$scope.task.getUUID() + '/' + sheet.getUUID() + "/preview";
            }
        } else {
            path = '/sheet/' + sheet.getUUID();
        }

        this.$location.path(path);
    }

    /**
     * Handles click event on background resources.
     * @param {Object} sheet - The sheet object associated with the click event.
     */
    onBackgroundResourcesClick(sheet) {
        this.redirectToSheet(sheet);
    }

    /**
     * Handles click event on status map.
     * @param {string} selector - The selector string for the status map element.
     */
    onStatusMapClick(selector) {
        let selectorString = '#' + selector,
            className = 'open',
            targetSelector = '.tab-pane',
            currentSortType = $(targetSelector).attr('data-sortby');

        if (typeof currentSortType === 'undefined') {
            $(targetSelector).attr('data-sortby', 'order');
        }

        $(selectorString).toggleClass(className);
        if (!$(selectorString).hasClass(className)) {
            $('.tab-pane').attr('data-old-sortby', $('.tab-pane').attr('data-sortby'));
            $('.tab-pane').attr('data-sortby', '');
        } else {
            $('.tab-pane').attr('data-sortby', $('.tab-pane').attr('data-old-sortby'));
            $('.tab-pane').removeAttr('data-old-sortby');
        }
    }

    /**
     * Handles click event on status map item.
     * @param {Object} sheet - The sheet object associated with the status map item.
     */
    onStatusMapItemClick(sheet) {
        let uuid = sheet.getUUID(),
            targetSelector = '#status-map-question-group-' + uuid,
            collapseTrigger = 'in';

        $(targetSelector).toggleClass(collapseTrigger);
    }

    /**
     * Handles click event on status map sort by button.
     * @param {string} tabname - The name of the tab to sort by.
     */
    onStatusMapSortByButtonClick(tabname) {
        let targetSelector = '#' + tabname,
            groupButtonSelector = '.statusmap-button-tab',
            buttonSelector = '.by-' + tabname,
            groupSelector = '.tab-pane',
            showTrigger = 'active';

        $(groupSelector).removeClass(showTrigger);
        $(targetSelector).addClass(showTrigger);
        $(groupButtonSelector).removeClass(showTrigger);
        $(buttonSelector).addClass(showTrigger);
    }

    /**
     * Handles click event on status map subquestion item.
     * @param {Object} questionPart - The question part object associated with the subquestion item.
     */
    onStatusMapSubquestionItemClick(questionPart) {
        this.$logger.info(this.$scope, 'onQuestionItemClick with UUID ', questionPart.getUUID());

        let sheet = this.$scope.task.findSheetWithQuestionPart(questionPart),
            sheetUrl = '/sheet/' + sheet.getUUID();

        if (questionPart.isBookmarked()) {
            sheetUrl = sheetUrl + '/' + questionPart.getUUID();
        }
        this.$location.path(sheetUrl);
    }

    /**
     * Handles click event on status map sort button.
     * @param {string} sortby - The sort type to apply.
     */
    onStatusMapSortButtonClick(sortby) {
        let selector = '.tab-pane';

        $(selector).attr('data-sortby', sortby);
    }
}